import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import {
  SetVerifiedUserActions,
  SetEmployeeProfileDetailsID,
  SetStatusBTN,
  SetISPendingDetails,
  setEditableActions, ///readable
  StetheAttendanceExportActions,
  setTheUserObjects, /////--user---objects
  sethtmlformatpdfdownoadActions, ////---pdf----formats---------------
  setThePageIndex,
  setTheApproveRequeststate,
  setTheUser_ID ,
  resetUnblockActions_opretions,
  setTheBranchObject,
  setTablePositionPersist
} from "../../../Redux/Slice";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import SiteCreateEdit from "../SiteTransfer/SiteCreateEdit";
import BlackListCeatePoup from "../Blacklist/BlackListCreatePop";
import GridOnIcon from "@material-ui/icons/GridOn";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import ActiveEmployeeCreate from "../Active/ActiveEmployeeCreate";
import ExcelFormatDwonload from "./ExcelFormatDwonload";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import ReactTable from "../../AppComponent/Table";

import _ from "lodash";
import SiteTransferIm from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-29.svg";
import BlockImg from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-09.svg";
import ActiveImgs from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-30.svg";
import ExcelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-12.svg"


import AttendanceExportImg from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";
import allformPdf from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-09.svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";

import BlockImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-31.svg";


const ApproveEmployee = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const Swal = require("sweetalert2");
  const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)

  const navigate = useNavigate();
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);

  // const [searchemp, setsearchEmp] = useState("");
  const [searchemp,setsearchEmp] = useState(
      TablePositionPersist?.Appprove_empDatas?.search == undefined ||
      TablePositionPersist?.Appprove_empDatas?.search == ""
        ? ''
        : TablePositionPersist?.Appprove_empDatas?.search
    );  
  
  const [Emptotalcoun, setTotallCount] = useState();
  const [EmpDAta, setEmpdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);

  const [ExcelSheeTFORKYCPopup, setExcelSheetFORKYCPopup] = useState(false);
  ////--Black---list---------------------------------------
  const [EmployeePop, setEmployeePopblack] = useState(false);
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.Appprove_empDatas?.page == undefined
      ? 1
      : TablePositionPersist.Appprove_empDatas.page
  );
  
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [sno, setsno] = useState(0);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  ///---InActive----Create---
  const [InActiveCreatePop, setInActiveCreatePoup] = useState(false);
  const [InActiveCreateId, setInactiveCrateId] = useState("");
  const [toggleActive, setTogleActive] = useState(
    false);
  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });
  const [OldEmp, setOldEMp] = useState({
    label: "NEW EMPLOYEE",
    value: false,
  });

  const oldemloyeeOptions = [
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];

  const [oldemplo, setoldemp] = useState({ old_employee: false });

  
    const Block_lists = [

      {
        value: true,
        label: "BLOCKED EMPLOYEES",
      },
    ];
    const [BlockEmp, setBlockEMp] = useState({
      label: "",
      value: "",
    });
    const [Block_request, setblockrequesr] = useState({ black_list: "" });
  

  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 2) {
      const payload = {
        search: searchemp,
        page_size: 20,
        // page: state.NeededdatasListed.PageIndex,
        page: dtpageindex,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        //client_id: state.ClientBranchIDs.ClientBranchID,
        old_employee: oldemplo.old_employee,
        black_list:Block_request?.black_list
      };
      dispatch(SetVerifiedUserActions(payload));
          dispatch(
            setTablePositionPersist({ data: payload, pageName: "Appprove_empDatas" })
          );
      
    }
  }, [state.clientDetailsCall.ActiveClinetTabs, oldemplo, dtpageindex, searchemp,Block_request]);

  // console.log("dtpageindexEMp", oldemplo, dtpageindex);
  useEffect(() => {
    if (state.VerifiedUsers.VerifiedUsersData != undefined) {
      setEmpdatas(state.VerifiedUsers.VerifiedUsersData);
      setTotallCount(state.VerifiedUsers.Total_Count);
    }
    // console.log(
    // state.VerifiedUsers.VerifiedUsersData.inquiry_data,
    // EmpDAta,
    // "isfadoi9opj"
    // );
  }, [state.VerifiedUsers.VerifiedUsersData]);

  const attendanceexportEmp = (e, statement, values) => {
    // console.log(values, statement, e, "auysfdasdasdyasdlas");
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${statement ? "based on this month to  end of the  month" : ""
        }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: "employee",
          client_id: "",
          user_id: values.user_id,
          data: values.data,
          Dob: [],
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };


  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };
  // console.log(oldemplo.old_employee , "old_employee",!oldemplo.old_employee,oldemplo.old_employee == false);
  const handleAllFormPdf = (id) => {
    const payload = {
      id: id,
      count: 1,
    };
    dispatch(sethtmlformatpdfdownoadActions(payload));

  }

  const columnsemp = [
 {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
//      {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);
        return (
          <>
            <div className="UserName"

              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              style={{ position: 'relative' }} // Relative positioning for tooltip placement
            >
              {/* {row.row.original.user_id != undefined &&
              row.row.original.user_id != null &&
              row.row.original.user_id.user_image != undefined &&
              row.row.original.user_id.user_image != null &&
              row.row.original.user_id.user_image.media_url != undefined &&
              row.row.original.user_id.user_image.media_url != null ? (
                <div className="ProfilImg">
                  <img src={row.row.original.user_id.user_image.media_url} />
                </div>
              ) : (
                <div className="ProfilImg">
                  <img src={profile2} />
                </div>
              )} */}
              <div className="">
                {row.row.original.user_id.first_name != undefined &&

                  row.row.original.user_id.first_name != null && row.row.original.user_id.first_name != "" ?
                  <span

                  >
                    {row.row.original.user_id.first_name.length > 15 ? truncateText(row.row.original.user_id.first_name, 15) :

                      <>
                        {row.row.original.user_id.first_name}
                      </>
                    }

                    {showTooltip && (
                      <div className="custom-tooltip">
                        {row.row.original.user_id.first_name}
                      </div>
                    )}

                  </span>



                  :
                  <span>{"---"}</span>
                }
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Designation",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <span>
              {row.row.original.user_id.user_role.role != null &&
                row.row.original.user_id.user_role.role != undefined &&
                row.row.original.user_id.user_role.role != "" ? (
                <div className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: 'relative' }}
                >

                  <>
                    {
                      // row.row.original.role.length > 10 ? (
                      //   truncateText(row.row.original.role, 10)
                      // ) :
                      (
                        <>{row.row.original.user_id.user_role.role}</>
                      )}
                  </>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_id.user_role.role}
                    </div>
                  )}

                </div>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span
            >
              {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "Verification",
      accessor: "",
      Cell: (row) => {
        const [hovered, setHovered] = useState(null); // Hover state for tooltips

        return (
          <>
            <>
              {/* ////-----------------Approvel---Status------For Decline , is_pending  have to false and job_description.letter_id is should not
             be undefined
            */}
              <div className="StatusList">
                {row.row.original?.is_exited == true ? 
                 <>
                {/* <img src={correctIcons} />
                <span
                style={{ color: "#d9534f", fontWeight: 600 }}>Exited</span> */}
                <div className="StatusList">
            <div className="DeclineStatus" style={{marginTop:"-5px"}}>
              <span>x</span>
            </div>
            <span style={{ color: "#d9534f", fontWeight: 600 }}>Exited</span>
          </div>

                </>
                :
                   <>
                <img src={correctIcons} />
                <span>Approve</span>
                </>  
              }
             
             {row.row.original?.is_exited ? "": 

      <>
                {row.row.original?.job_description?.letter_id?.media_url && (
                  <span className="AllformExcel"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(
                        row.row.original.job_description.letter_id.media_url,
                        "_blank"
                      );
                    }}
                    style={{ position: "relative" }}
                    onMouseEnter={() => setHovered("offer-letter")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <img src={downloadoffer} />
                    {hovered === "offer-letter" && (
                      <div className="custom-tooltip">Offer Letter</div>
                    )}
                  </span>
                )}

                {oldemplo.old_employee === false && row.row.original?.user_id && (
                  <>
                    <span className="AllformExcelclient"
                      onClick={(e) => {
                        e.stopPropagation();
                        const payloads = {
                          export_type: "employee",
                          client_id: "",
                          user_id: row.row.original.user_id.id,
                          data: data,
                          Dob: [],
                        };
                        if (startDatemon === data.from_date && endDatemon === data.to_date) {
                          attendanceexportEmp(e, true, payloads);
                        } else {
                          attendanceexportEmp(e, false, payloads);
                        }
                      }}
                      style={{ position: "relative" }}
                      onMouseEnter={() => setHovered("Attendance export")}
                      onMouseLeave={() => setHovered(null)}

                    >

                      <img src={AttendanceExportImg} />
                      {hovered === "Attendance export" && (
                        <div className="custom-tooltip">Attendance export</div>
                      )}
                    </span>


                    <span className="AllformExcelclient"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAllFormPdf(row.row.original.user_id.id);

                      }}
                      style={{ position: "relative" }}
                      onMouseEnter={() => setHovered("All form pdf")}
                      onMouseLeave={() => setHovered(null)}

                    >
                      <img src={allformPdf} />
                      {hovered === "All form pdf" && (
                        <div className="custom-tooltip">All form pdf</div>
                      )}
                    </span>
                  </>
                )}
      </>
              }
              </div>





            </>
          </>
        );
      },

      //
    },
    oldemplo.old_employee == false && {
      Header: "Export excel sheet",
      accessor: "",
      Cell: (row) => {
        const [hovered, setHovered] = useState(null);
        return (
          <>
            {row.row.original.user_id != undefined &&
              row.row.original.user_id.id != undefined &&
              row.row.original.user_id.id != null ? (
              <div
                className="UserName"
              >

                <div>
                  <button
                    class="btn "
                    onClick={(e) => {
                      e.stopPropagation();
                      setidforuploaddata({
                        ...getidforupload,
                        user_id: row.row.original.user_id.id,
                        client_id: "",
                      });
                      setExcelSheetFORKYCPopup(true);
                    }}
                    style={{ position: "relative", background: "#d8e2fb", color: "#234492", display: "flex", gap: "3px" }}
                    onMouseEnter={() => setHovered("Excel Sheet")}
                    onMouseLeave={() => setHovered(null)}
                    // disabled={row.row.original?.is_exited}

                  >
                    <span className="ExcelSheetImages">
                      <img src={ExcelSheetImage} />
                      {hovered === "Excel Sheet" && (
                        <div className="custom-tooltip">Excel Sheet</div>
                      )}
                    </span>
                    Excel Sheet
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>{"-----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        const [hovered, setHovered] = useState(null);
        return (
          <>
            <div
              className="EmployeeDetailsActions"
              style={{
                display: "flex",
                gap: "10px",
                zIndex: "0",
                position: "relative",
              }}
            >
              {
              Block_request?.black_list == false && 
              row.row.original != undefined &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != null ? (
                <button
                  class="btn SiteTransferBtm"
                  style={{ background: "#234492", color: "white", position: "relative" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    ////-----user----Ids
                    dispatch(
                      setTheUserObjects({
                        value: row.row.original.user_id.id,
                        label: row.row.original.user_id.first_name,
                      })
                    );
                    setcreatepoup(true);
                    setEmployeeIDs("");
                  }}

                  onMouseEnter={() => setHovered("Site Transfer")}
                  onMouseLeave={() => setHovered(null)}
                  disabled={row.row.original?.is_exited}

                >
                  {/* {" "}
                        Site Transfer */}
                  {/* <i
                    class="fa-solid fa-sitemap"
                    // style={{ paddingLeft: "12px" }}
                  ></i> */}
                  <span className="ExcelSheetImages">
                    <img src={SiteTransferIm} />
                    {hovered === "Site Transfer" && (
                      <div className="custom-tooltip">Site Transfer</div>
                    )}
                  </span>
                </button>
              ) : null}

              {
              Block_request?.black_list == false &&
              row.row.original != undefined &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != null ? (
                <>
                  <button
                    class="btn BlockBtn"
                    style={{ background: "#234492", color: "white", position: "relative" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      ////-----user----Ids
                      dispatch(
                        setTheUserObjects({
                          value: row.row.original.user_id.id,
                          label: row.row.original.user_id.first_name,
                        })
                      );
                      setcreatepoupblack(true);
                      setEmployeeIDsblack("");
                    }}
                    onMouseEnter={() => setHovered("Block")}
                    onMouseLeave={() => setHovered(null)}
                                      disabled={row.row.original?.is_exited}


                  >

                    <span className="ExcelSheetImagesBlock">
                      <img src={BlockImage} />
                      {hovered === "Block" && (
                        <div className="custom-tooltip">Block</div>
                      )}

                    </span>
                  </button>
                </>
              ) : null}
                      {Block_request?.black_list == true && (
                                <button
                    class="btn BlockBtn"
                    style={{ background: "#234492", color: "white", position: "relative" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    Swal.fire({
title: "Are you sure you want to unblock this employee?",
text: "Please provide your remarks to proceed.",
                                      input: "textarea",
                                      inputPlaceholder: "Enter remarks here...",
                                      inputAttributes: {
                                        "aria-label": "Enter remarks here",
                                      },
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, Unblock",
                                      cancelButtonText: "Cancel",
                                      confirmButtonColor: "#234492", // theme color
                                      cancelButtonColor: "#6c757d",
                                      preConfirm: (remarks) => {
                                        if (!remarks || remarks.trim() === "") {
                                          Swal.showValidationMessage("Remarks are required!");
                                          return false;
                                        }
                                        return remarks;
                                      },
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        const remarks = result.value;
                                        console.log("Employee unblocked:", row.row.original ,row.row.original.user_id?.id ,remarks);
                                        console.log("Remarks:", remarks);
                const payloads = {
                  form_data:{
                    unblock_reason:remarks,
                  status:"unblocked",
                  },
                  EditId:row.row.original.user_id?.id,
                  Delete_api_calls:{
        search: searchemp,
        page_size: 20,
        page: dtpageindex,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        old_employee: oldemplo.old_employee,
        black_list:Block_request?.black_list
                
                  },
                  Call_deleted_:2,
                
                }
                                        // ✅ Place your unblock logic here
                                        dispatch(resetUnblockActions_opretions(payloads))
                                      }
                                    });
                                  }}
                                >
                                  <span className="ExcelSheetImagesBlock">
                      <img src={BlockImage} />
                                  </span>
                                </button>
                              )}
            </div>
          </>
        );
      },
    },
    // ];
  ].filter(Boolean);

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setdtPageindex(1);
        setsearchEmp(e)
        // const payload = {
        //   search: e,
        //   page_size: 20,
        //   client_id: state.ClientBranchIDs.clientBranchEditView,
        //   page: 1,
        //   old_employee: oldemplo.old_employee,
        // };
        // // console.log(e, "testnew")
        // dispatch(SetVerifiedUserActions(payload));

      }, 500),
    []
  );


  function tochangeEmp(e) {
    // console.log("ee", e);
    // setsearchEmp(e);
    debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() !== "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: 10,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     page: 1,
    //     old_employee: oldemplo.old_employee,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(SetVerifiedUserActions(payload));
    // }
    // if (e == "" || searchemp == "") {
    //   const payload = {
    //     search: "",
    //     page_size: 10,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     old_employee: oldemplo.old_employee,
    //   };
    //   dispatch(SetVerifiedUserActions(payload));
    // }
  }


  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);




  ////-------------------Employee----Forms----Details
  const handleEmployeeDetails = (id) => {
    if(Block_request?.black_list == true ) {
return;
    }else {
    if (!oldemplo.old_employee) {
      dispatch(setTheApproveRequeststate(3))

      console.log(id.user_id.id, "isfsd", id);
      dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
      dispatch(setTheUser_ID(id.user_id.id))
      dispatch(SetISPendingDetails(id.is_pending));
      dispatch(setEditableActions(1)); /// to---make ---as 0------readable---only
      dispatch(SetStatusBTN(true));
      navigate("/employeeprofile");
      // window.location.href = "/employeeprofile";
    }
  }
  };

  const HandleOldemployee = (e) => {
    // setdtPageindexemp(1);
    // setPageIndexDatEmp(1);
    // setdtPageindexEMP(1);
    setdtPageindex(1);
    setOldEMp(e);

    //   const payload = {
    //     search: searchemp,
    //     page_size: 10,
    //     // page: state.NeededdatasListed.PageIndex,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     //client_id: state.ClientBranchIDs.ClientBranchID,
    //     old_employee: e.value,
    //   };
    //   dispatch(SetVerifiedUserActions(payload));

    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }

    // dispatch(setThePageIndex(1));
  };

  //   const pagesizeemp = (arg) => {
  //     setdtPagesizeemp(arg);
  //     setdtPagesizeEMp(arg);
  //   };
  //   const pageindexemp = (arg) => {
  //     console.log(arg, "args");
  //     // setdtPageindexemp(arg);
  //     // setdtPageindexEMP(arg);
  //     setPageIndexDatEmp(arg);

  //     // dispatch(setThePageIndex(arg));
  //   };

  const handleNext = (next) => {
    console.log(next, "woiquenext");

    setdtPageindex(next + 1);

  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };
    const HandleBlockemployee = (e) => {
    setdtPageindex(1);
    setBlockEMp(e);

    if (e != null) {
      setblockrequesr({
        ...Block_request,
        black_list: e.value,
      });
    }
    else {
         setblockrequesr({
        ...Block_request,
        black_list: "",
      });
    }
  };

  return (
    <>
      {/* <button onClick={(e)=>{setdtPageindex(1)}}>{dtpageindex}</button> */}
      <div
        style={{
          padding: "0px",
        }}
      >
        <ReactTable
          data={EmpDAta}
          columns={columnsemp}
          totalItems={
            // Emptotalcoun
            state.VerifiedUsers.Total_Count
          }
          currentPage={1}
          // onPageChange={handlePageChange}
          onChange={tochangeEmp}
          //   setCurrentPage={setCurrentPageemp}

          pagesize={pagesize}
          dtpagesize={pageSize}
          pageindex={pageindex}
          datacount={
            // Emptotalcoun
            state.VerifiedUsers.Total_Count
          }
          dtpageindex={dtpageindex}
          MakeCreate={true}
          ViewParts={(e) => {
            handleEmployeeDetails(e);
          }}
          OldEmployeFilters={true}
          oldemloyeeOptions={oldemloyeeOptions}
          OldEmp={OldEmp}
          Filter={true}
          HandleOldemployee={(e) => {
            HandleOldemployee(e);
          }}
          onPrevious={handlePrevious}
          onNextpage={handleNext}
          GotoEnteredPage={GotoEnteredPage}

          setsno={setsno}
          sno={sno}
          id={"spe"}
        // Oncreate={(e) => setRoleCreatePopup(true)}
         Block_listed_filter
            Block_lists={Block_lists}
            HandleBlockemployee={(e) => {
              HandleBlockemployee(e);
            }}
            BlockEmp={BlockEmp}
                                 searchVal={TablePositionPersist?.Appprove_empDatas?.search == "" || TablePositionPersist?.Appprove_empDatas?.search ==undefined? "":TablePositionPersist.Appprove_empDatas.search}
              search_key={true}

        />
      </div>

      <>
        {createpoup ? (
          <SiteCreateEdit
            show={createpoup}
            setShow={setcreatepoup}
            currentPage={newpages}
            EditId={EmployeeIDs}
            selectVal={""}
            datas={""}
                 Emp_old={oldemplo.old_employee}
          client_id_sfrom ={state.ClientBranchIDs.clientBranchEditView}
          searchemp={searchemp}
          page_size_approved={dtpageindex}
            Count_of_block={"3"}
          />
        ) : null}
      </>

      {/* ----Black----list---------------------------------- */}
      {createblack ? (
        <BlackListCeatePoup
          show={createblack}
          setShow={setcreatepoupblack}
          ActiveFor={1}
          currentPage={newpages}
          EditId={EmployeeIDsblacklist}
          selectVal={""}
          datas={""}

                           Emp_old={oldemplo.old_employee}
          client_id_sfrom ={state.ClientBranchIDs.clientBranchEditView}
          searchemp={searchemp}
          page_size_approved={dtpageindex}
          Count_of_block={"3"}
          
     
        />
      ) : null}

      <>
        {ExcelSheeTFORKYCPopup ? (
          <ExcelFormatDwonload
            show={ExcelSheeTFORKYCPopup}
            setShow={setExcelSheetFORKYCPopup}
            EditID={getidforupload}
          />
        ) : null}
      </>

      <>
        {InActiveCreatePop &&
          InActiveCreateId != "" &&
          InActiveCreateId != undefined ? (
          <ActiveEmployeeCreate
            show={InActiveCreatePop}
            setShow={setInActiveCreatePoup}
            UserID={InActiveCreateId}
            ActiveFor={1}
            setTogleActive={setTogleActive}
          />
        ) : null}
      </>
    </>
  );
};

export default ApproveEmployee;
